import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { base } from "../../constants/base";
import { getUserRole } from "../../privateroutes/auth";

/**
 * Home link + logged-in user's avatar/name/role, shown at the top of the
 * off-canvas dashboard sidebar (tablet/mobile) so the drawer is one
 * self-contained panel instead of splitting this info into the header's
 * separate collapse above it.
 */
const DashboardSidebarHeader = () => {
    const user = useSelector((state) => state?.AuthSlice?.user);
    const userRole = getUserRole();

    return (
        <div className="dashboard-sidebar-header">
            <div className="dashboard-sidebar-profile">
                {user?.images?.[0]?.path ? (
                    <img src={`${base.imageUrl}${user.images[0].path}`} alt="" />
                ) : (
                    <img src="/images/user-demo.jpg" alt="" />
                )}
                <div>
                    <h4>{user?.name}</h4>
                    <h6>{userRole}</h6>
                </div>
            </div>

            <Link to="/" className="dashboard-sidebar-home-link">
                <i className="fa-solid fa-house"></i> Home
            </Link>

            {userRole === "user" && (
                <Link to="/find/services" className="dashboard-sidebar-home-link">
                    <i className="fa-solid fa-magnifying-glass"></i> Find Services
                </Link>
            )}
        </div>
    );
};

export default DashboardSidebarHeader;
